import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/index';
import config from './config';
import api from './services/data.services';
import auth from './services/auth.services';
import util from './util';
import atenaList from './services/atenaList.services';
import globals from './globals';
import Popper from 'popper.js';
import moment from '@/utils/moment';

import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields',
  errorBagName: 'veeErrors'
});

import Dialog from 'bootstrap-vue-dialog/dist/bootstrap-vue-dialog';
Vue.use(Dialog);

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

/* PLUGIN COMPONENTS START */
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    libraries: 'places'
  }
});

import { VueSpinners } from '@saeris/vue-spinners';
Vue.use(VueSpinners);

import ElementUI from 'element-ui';
import { ElementTiptapPlugin } from 'element-tiptap';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-tiptap/lib/index.css';
Vue.use(ElementUI);
Vue.use(ElementTiptapPlugin, { lang: 'pt_br' });

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas, faClock } from '@fortawesome/free-solid-svg-icons';
library.add(fas);
library.add(faClock);
Vue.component('font-awesome-icon', FontAwesomeIcon);

import Notifications from 'vue-notification';
import Toasted from 'vue-toasted';

Vue.use(Notifications);
Vue.use(Toasted);

// Plugin de máscaras - https://vuejs-tips.github.io/vue-the-mask/
import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import money from 'v-money';
Vue.use(money, { precision: 2 });

// Plugin para validaçao de forms - https://vuelidate.netlify.com/
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

/* PLUGIN COMPONENTS END */

/* PLUGIN & CUSTOM DIRECTIVES */

import { mask, tokens } from 'vue-the-mask';
Vue.directive('v-mask', { mask });

// Definindo tokens personalizados para as mascaras
tokens.A = { pattern: /[a-zA-Z0-9_]/ }; // Aceita letras, números e underscore
tokens.B = { pattern: /^[a-zA-Z0-9_-]+$/ }; //token para máscara customizado aceita letras, números (-) ou (_)
tokens.C = { pattern: /[a-zA-Z0-9]/ }; // Aceita letras, números.

/* PLUGIN & CUSTOM DIRECTIVES */

/* COMMON COMPONENTS START */
import { ValidationProvider } from 'vee-validate';
Vue.component('validation-provider', ValidationProvider);

import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);

import SelectorMulti from '@/components/common/SelectorMulti.vue';
Vue.component('selector-multi', SelectorMulti);

import SelectorMultiGames from '@/components/common/SelectorMultiGames.vue';
Vue.component('selector-multi-games', SelectorMultiGames);

import SelectorCentroDeCusto from './components/common/SelectorCentroDeCusto';
Vue.component('sel-centro-de-custo', SelectorCentroDeCusto);

import SelectorLocalidade from './components/common/SelectorLocalidade';
Vue.component('sel-localidade', SelectorLocalidade);

import SelectorLocalidadeSite from './components/common/SelectorLocalidadeSite';
Vue.component('sel-localidade-site', SelectorLocalidadeSite);

import MultiSelectorStatic from './components/common/MultiSelectorStatic.vue';
Vue.component('multi-selector', MultiSelectorStatic);

import ExportOptionsDropdown from './components/common/ExportOptionsDropdown';
Vue.component('export-options-dropdown', ExportOptionsDropdown);

import InputTelefone from './components/common/InputTelefone.vue';
Vue.component('input-telefone', InputTelefone);

import InputDocumento from './components/common/InputDocumento.vue';
Vue.component('input-documento', InputDocumento);

import InputChavePix from './components/common/InputChavePix.vue';
Vue.component('chave-pix-input', InputChavePix);

import SelectorStatic from './components/common/SelectorStatic';
Vue.component('selector', SelectorStatic);

import SelectorTimezone from './components/common/SelectorTimezone';
Vue.component('sel-timezone', SelectorTimezone);

import SelectorSaldo from './components/common/SelectorSaldo';
Vue.component('sel-saldo', SelectorSaldo);

import SelectorSearchScreens from './components/common/SelectorSearchScreens';
Vue.component('sel-search-screens', SelectorSearchScreens);

import SelectorEmpresa from './components/common/SelectorEmpresa';
Vue.component('sel-empresa', SelectorEmpresa);

import SelectorSecao from './components/common/SelectorSecao';
Vue.component('sel-secao', SelectorSecao);

import SelectorIdioma from './components/common/SelectorIdioma';
Vue.component('sel-idioma', SelectorIdioma);

import SelectorIdiomaPadrao from './components/common/SelectorIdiomaPadrao';
Vue.component('sel-idioma-padrao', SelectorIdiomaPadrao);

import SelectorMenu from './components/common/SelectorMenu';
Vue.component('sel-menu', SelectorMenu);

import SelectorEstabelecimento from './components/common/SelectorEstabelecimento';
Vue.component('sel-estabelecimento', SelectorEstabelecimento);

import SelectorRota from './components/common/SelectorRota';
Vue.component('sel-rota', SelectorRota);

import StatusBilhete from './components/common/StatusBilhete';
Vue.component('status-bilhete', StatusBilhete);

import StatusBilheteBetbuilder from './components/common/StatusBilheteBetbuilder';
Vue.component('status-bilhete-betbuilder', StatusBilheteBetbuilder);

import StatusPin from './components/common/StatusPin';
Vue.component('status-pin', StatusPin);

import StatusEventoBilhete from './components/common/StatusEventoBilhete';
Vue.component('status-evento-bilhete', StatusEventoBilhete);

import SelectorEstado from './components/common/SelectorEstado';
Vue.component('sel-estado', SelectorEstado);

import SelectorStatusSaque from './components/common/SelectorStatusSaque';
Vue.component('sel-status-saque', SelectorStatusSaque);

import SelectorStatusPin from './components/common/SelectorStatusPinV2';
Vue.component('sel-status-pin', SelectorStatusPin);

import SelectorTipoCobranca from './components/common/SelectorTipoCobranca';
Vue.component('sel-tipo-cobranca', SelectorTipoCobranca);

import SelectorCidade from './components/common/SelectorCidade';
Vue.component('sel-cidade', SelectorCidade);

import SelectorPaises from './components/common/SelectorPaises';
Vue.component('sel-pais', SelectorPaises);

import SelectorTipoEsporte from './components/common/SelectorTipoEsporte';
Vue.component('sel-tipo-esporte', SelectorTipoEsporte);

import SelectorTipoAfiliado from './components/common/SelectorTipoAfiliado';
Vue.component('sel-tipo-afiliado', SelectorTipoAfiliado);

import SelectorProduto from './components/common/SelectorProduto';
Vue.component('sel-produto', SelectorProduto);

import SelectorTipoProduto from './components/common/SelectorTipoProduto';
Vue.component('sel-tipo-produto', SelectorTipoProduto);

import SelectorTipoProdutoList from './components/common/SelectorTipoProdutoList';
Vue.component('sel-tipo-produto-list', SelectorTipoProdutoList);

import SelectorModeloImpressora from './components/common/SelectorModeloImpressora';
Vue.component('sel-modelo-impressora', SelectorModeloImpressora);

import SelectorLayoutMetabaseDashboard from './components/common/SelectorLayoutMetabaseDashboard';
Vue.component('sel-layout-metabase-dashboard', SelectorLayoutMetabaseDashboard);

import SelectorPerfilMetabaseDashboard from './components/common/SelectorPerfilMetabaseDashboard';
Vue.component('sel-perfil-metabase-dashboard', SelectorPerfilMetabaseDashboard);

import SelectorTipoSubEvento from './components/common/SelectorTipoSubEvento';
Vue.component('sel-tipo-subevento', SelectorTipoSubEvento);

import SelectorTipoSubEventoMulti from './components/common/SelectorTipoSubEventoMulti';
Vue.component('sel-tipo-subevento-multi', SelectorTipoSubEventoMulti);

import SelectorTipoResultado from './components/common/SelectorTipoResultado';
Vue.component('sel-tipo-resultado', SelectorTipoResultado);

import SelectorGrupoEvento from './components/common/SelectorGrupoEvento';
Vue.component('sel-grupo-evento', SelectorGrupoEvento);

import SelectorEvento from './components/common/SelectorEvento';
Vue.component('sel-evento', SelectorEvento);

import SelectorEventoInternalProvider from './components/common/SelectorEventoInternalProvider';
Vue.component('sel-evento-internal-provider', SelectorEventoInternalProvider);

import DateInput from './components/helpers/DateInput';
Vue.component('date-input', DateInput);

import SelectorTodos_Sim_Nao from './components/common/SelectorTodos_Sim_Nao';
Vue.component('sel-todos-sim-nao', SelectorTodos_Sim_Nao);

import SelectorTeste_Sim_Nao from './components/common/SelectorTeste_Sim_Nao';
Vue.component('sel-teste-sim-nao', SelectorTeste_Sim_Nao);

import SelectorStatusLogins from './components/common/SelectorStatusLogins';
Vue.component('sel-status-logins', SelectorStatusLogins);

import SelectorPendenciaLogins from './components/common/SelectorPendenciaLogins';
Vue.component('sel-pendencia-logins', SelectorPendenciaLogins);

import BrMoneyInput from './components/helpers/BrMoneyInput';
import i18n from './i18n';
Vue.component('br-money-input', BrMoneyInput);

import VueFlagIcon from 'vue-flag-icon';
Vue.use(VueFlagIcon);

import SelectorTipoMetodoPagamento from './components/common/SelectorTipoMetodoPagamento';
Vue.component('sel-tipo-metodo-pagamento', SelectorTipoMetodoPagamento);

import SelectorTipoFornecedor from './components/common/SelectorTipoFornecedor';
Vue.component('sel-tipo-fornecedor', SelectorTipoFornecedor);

import SelectorMetodoPagamento from './components/common/SelectorMetodoPagamento';
Vue.component('sel-metodo-pagamento', SelectorMetodoPagamento);

import SelectorSite from './components/common/SelectorSite';
Vue.component('sel-site', SelectorSite);

import SelectorCategoria from './components/common/SelectorCategoria';
Vue.component('sel-categoria', SelectorCategoria);

import SelectorMotivoBloqueioUsuario from './components/common/SelectorMotivoBloqueioUsuario';
Vue.component('sel-motivo-bloqueio-usuario', SelectorMotivoBloqueioUsuario);

import SelectorUsuario from './components/common/SelectorUsuario';
Vue.component('sel-usuario', SelectorUsuario);

import SelectorEsporte from './components/common/SelectorEsporte';
Vue.component('sel-esporte', SelectorEsporte);

import SelectorUsuarioUpdate from './components/common/SelectorUsuarioUpdate';
Vue.component('sel-usuarios', SelectorUsuarioUpdate);

import MultiSelectorCompeticao from './components/common/MultiSelectorCompeticao';
Vue.component('multi-competicao', MultiSelectorCompeticao);

import MultiSelectorEvento from './components/common/MultiSelectorEvento';
Vue.component('multi-evento', MultiSelectorEvento);

import MultiSelectorEsporte from './components/common/MultiSelectorEsporte';
Vue.component('multi-esporte', MultiSelectorEsporte);

import MultiSelectorTiposTransacao from './components/common/MultiSelectorTiposTransacao';
Vue.component('multi-tipos-transacao', MultiSelectorTiposTransacao);

import Gloading from './components/helpers/gloading/gloading';
Vue.component('g-loading', Gloading);

import SelectorPerfil from './components/common/SelectorPerfil';
Vue.component('sel-perfil', SelectorPerfil);

import SelectorLocalidadesTransacoes from './components/common/SelectorLocalidadesTransacoes';
Vue.component('sel-localidades-transacoes', SelectorLocalidadesTransacoes);

import CurrencyInput from './components/helpers/CurrencyInput';
Vue.component('currency-input', CurrencyInput);
Vue.component('float-input', CurrencyInput);

import IntegerInput from './components/helpers/IntegerInput';
Vue.component('integer-input', IntegerInput);

import DecimalInput from './components/helpers/DecimalInput';
Vue.component('decimal-input', DecimalInput);

import SelectorLocalidadeEmpresas from './components/common/SelectorLocalidadeEmpresas';
Vue.component('sel-localidade-empresas', SelectorLocalidadeEmpresas);

import SelectorEmpresas from './components/common/SelectorEmpresas';
Vue.component('sel-empresas', SelectorEmpresas);

import SelectorPerfilObj from './components/common/SelectorPerfilObj';
Vue.component('sel-perfil-obj', SelectorPerfilObj);

import SelectorSiteObj from './components/common/SelectorSiteObj';
Vue.component('sel-site-obj', SelectorSiteObj);

import SelectorSitesAffiliates from './components/common/SelectorSitesAffiliates';
Vue.component('sel-affiliates-sites', SelectorSitesAffiliates);

import SelectorSitesAffiliatesRoot from './components/common/SelectorSitesAffiliatesRoot';
Vue.component('sel-affiliates-sites-root', SelectorSitesAffiliatesRoot);

import SelectorTipoMetodoPagamentoObj from './components/common/SelectorTipoMetodoPagamentoObj';
Vue.component('sel-tmp-obj', SelectorTipoMetodoPagamentoObj);

import SelectorBanco from './components/common/SelectorBanco';
Vue.component('sel-banco', SelectorBanco);

import SelectorTipoArquivoSigap from './components/common/SelectorTipoArquivoSigap';
Vue.component('sel-tipo-arquivo-sigap', SelectorTipoArquivoSigap);

import SelectorHolder from './components/common/SelectorHolder';
Vue.component('sel-holder', SelectorHolder);

import SelectorPremio from '@/components/common/SelectorPremio.vue';
Vue.component('sel-premio', SelectorPremio);

import SelectorTipoTransacaoBancaria from './components/common/SelectorTipoTransacaoBancaria';
Vue.component('sel-tipo-transacao-bancaria', SelectorTipoTransacaoBancaria);

import MultiSelectorMetodoPagamento from './components/common/MultiSelectorMetodoPagamento';
Vue.component('multi-sel-metodo-pagamento', MultiSelectorMetodoPagamento);

import SelectorTemplateMetodoPagamento from './components/common/SelectorTemplateMetodoPagamento';
Vue.component('sel-template-mp', SelectorTemplateMetodoPagamento);

import SelectorTemplateMetodoPagamentoLocalidade from './components/common/SelectorTemplateMetodoPagamentoLocalidade';
Vue.component('sel-template-mp-localidade', SelectorTemplateMetodoPagamentoLocalidade);

import SelectorLocalidadeObj from './components/common/SelectorLocalidadeObj';
Vue.component('sel-localidade-obj', SelectorLocalidadeObj);

import SelectorSiteMetodoPagamento from './components/common/SelectorSiteMetodoPagamento';
Vue.component('sel-site-metodo-pagamento', SelectorSiteMetodoPagamento);

import SelectorSiteEmpresas from './components/common/SelectorSiteEmpresas';
Vue.component('sel-site-empresas', SelectorSiteEmpresas);

import SelectorTemplateOdd from './components/common/SelectorTemplateOdd';
Vue.component('sel-template-odd', SelectorTemplateOdd);

import SelectorFornecedor from './components/common/SelectorFornecedor';
Vue.component('sel-fornecedor', SelectorFornecedor);

import SelectorGrupoOrigem from './components/common/SelectorGrupoOrigem';
Vue.component('sel-grupo-origem', SelectorGrupoOrigem);

import SelectorGerenciaGrupoEvento from './components/common/SelectorGerenciaGrupoEvento';
Vue.component('sel-gerencia-grupo-evento', SelectorGerenciaGrupoEvento);

import StatusLive from './components/common/StatusLive';
Vue.component('status-live', StatusLive);

import StatusResultado from './components/common/StatusResultado';
Vue.component('status-resultado', StatusResultado);

import SelectorEventoBilhete from './components/common/SelectorEventoBilhete';
Vue.component('sel-evento-bilhete', SelectorEventoBilhete);

import MultiSelectorTemplateOdd from './components/common/MultiSelectorTemplateOdd';
Vue.component('multi-template-odd', MultiSelectorTemplateOdd);

import StatusVencedorEvento from './components/common/StatusVencedorEvento';
Vue.component('status-vencedor-evento', StatusVencedorEvento);

import StatusProcessamento from './components/common/StatusProcessamento';
Vue.component('status-processamento', StatusProcessamento);

import SelectorMultiEmpresa from './components/common/SelectorMultiEmpresa';
Vue.component('sel-multi-empresa', SelectorMultiEmpresa);

import SelectorTipoMetodoPagamentoMulti from './components/common/SelectorTipoMetodoPagamentoMulti';
Vue.component('sel-tipo-metodo-pagamento-multi', SelectorTipoMetodoPagamentoMulti);

import SelectorTipoGrupoMetodoPagamento from './components/common/SelectorTipoGrupoMetodoPagamento';
Vue.component('sel-tipo-grupo-metodo-pagamento', SelectorTipoGrupoMetodoPagamento);

import SelectorMetodoPagamentoSite from './components/common/SelectorMetodoPagamentoSite';
Vue.component('sel-metodo-pagamento-site', SelectorMetodoPagamentoSite);

import SelectorTipoUsuario from './components/common/SelectorTipoUsuario';
Vue.component('sel-tipo-usuario', SelectorTipoUsuario);

import SelectorTipoVenda from './components/common/SelectorTipoVenda';
Vue.component('sel-tipo-venda', SelectorTipoVenda);

import SelectorTipoVendaLoterico from './components/common/SelectorTipoVendaLoterico';
Vue.component('sel-tipo-venda-loterico', SelectorTipoVendaLoterico);

import SelectorTipoValidacaoCadastro from './components/common/SelectorTipoValidacaoCadastro';
Vue.component('sel-tipo-validacao-cadastro', SelectorTipoValidacaoCadastro);

import SelectorTipoResultadoStatic from './components/common/SelectorTipoResultadoStatic';
Vue.component('sel-tipo-resultado-static', SelectorTipoResultadoStatic);

import SelectorTipoResultadoStaticV2 from './components/common/SelectorTipoResultadoStaticV2';
Vue.component('sel-tipo-resultado-static-v2', SelectorTipoResultadoStaticV2);

import SelectorTipoResultadoBD from './components/common/SelectorTipoResultadoBD';
Vue.component('sel-tipo-resultado-bd', SelectorTipoResultadoBD);

import SelectorTipoResultadoOdin from './components/common/SelectorTipoResultadoOdin';
Vue.component('sel-tipo-resultado-odin', SelectorTipoResultadoOdin);

import SelectorTipoResultadoOdinV2 from './components/common/SelectorTipoResultadoOdinV2';
Vue.component('sel-tipo-resultado-odin-v2', SelectorTipoResultadoOdinV2);

import SelectorOpcaoTipoResultado from './components/common/SelectorOpcaoTipoResultado';
Vue.component('sel-opcao-tipo-resultado', SelectorOpcaoTipoResultado);

import SelectorStatusBilhete from './components/common/SelectorStatusBilhete';
Vue.component('sel-status-bilhete', SelectorStatusBilhete);

import SelectorStatusBilheteMultiple from './components/common/SelectorStatusBilheteMultiple';
Vue.component('sel-status-bilhete-multiple', SelectorStatusBilheteMultiple);

import SelectorGame from './components/common/SelectorGame';
Vue.component('sel-game', SelectorGame);

import SelectorTargetPromo from './components/common/SelectorTargetPromo';
Vue.component('sel-target-promo', SelectorTargetPromo);

import SelectorProviderGame from './components/common/SelectorProviderGame';
Vue.component('sel-provider-game', SelectorProviderGame);

import SelectorNodinCategoria from './components/common/SelectorNodinCategoria';
Vue.component('sel-nodin-categoria', SelectorNodinCategoria);

import SelectorTipoDespesa from './components/common/SelectorTipoDespesa.vue';
Vue.component('sel-tipo-despesa', SelectorTipoDespesa);

import SelectorBadgeList from './components/common/SelectorBadgeList';
Vue.component('sel-badge-list', SelectorBadgeList);

import SelectorTemplatePromo from './components/common/SelectorTemplatePromo';
Vue.component('sel-template-promo', SelectorTemplatePromo);

import SelectorPromo from './components/common/SelectorPromo';
Vue.component('sel-promo', SelectorPromo);

import StatusSolicitacaoSaque from './components/common/StatusSolicitacaoSaque';
Vue.component('status-solicitacao-saque', StatusSolicitacaoSaque);

import LineChart from './components/common/LineChart';
Vue.component('line-chart', LineChart);

import Switch from './components/helpers/InputSwitch';
Vue.component('sel-switch', Switch);

import SelectorStatusTickets from './components/common/SelectorStatusTickets';
Vue.component('sel-status-tickets', SelectorStatusTickets);

import SelectorTipoTickets from './components/common/SelectorTipoTickets';
Vue.component('sel-tipo-tickets', SelectorTipoTickets);

import SelectorUsuarioGestor from './components/common/SelectorUsuarioGestor';
Vue.component('sel-usuario-gestor', SelectorUsuarioGestor);

import SelectorSlug from './components/common/SelectorSlug';
Vue.component('sel-slug', SelectorSlug);

import SelectorGestorLoterico from './components/common/SelectorGestorLoterico';
Vue.component('sel-gestor-loterico', SelectorGestorLoterico);

import SelectorFornecedorOrigem from './components/common/SelectorFornecedorOrigem';
Vue.component('sel-fornecedor-origem', SelectorFornecedorOrigem);

import StatusQuantity from './components/common/StatusQuantity';
Vue.component('status-quantity', StatusQuantity);

import PasswordInput from './components/common/PasswordInput';
Vue.component('b-form-input-pass', PasswordInput);

import Avatar from './components/common/Avatar';
Vue.component('avatar', Avatar);

import IconSVG from './components/common/IconSVG';
Vue.component('icon-svg', IconSVG);

import FormWizard from './components/helpers/FormWizard';
Vue.component('wizard', FormWizard);

import IconInfo from './components/helpers/IconInfo';
Vue.component('icon-info', IconInfo);

import SelectorMoeda from './components/common/SelectorMoeda';
Vue.component('sel-moeda', SelectorMoeda);

import SelectorTipoDocumento from './components/common/SelectorTipoDocumento';
Vue.component('sel-tipo-documento', SelectorTipoDocumento);

/* COMMON COMPONENTS END */

Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

Vue.config.productionTip = false;
Vue.config.silent = false;

// Datetime format with timezone (Data e hora com fuso horário)
Vue.prototype.$moment = moment;

Vue.mixin({
  data: globals.data,
  computed: globals.computed
});

import '@/assets/theme.dark.scss';
import '@/assets/theme.light.scss';
import '@/assets/theme.eclipse.scss';

new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
